<template>
  <div class="product_item_wrapper mr_top">
    <!-- 优惠券icon展示 -->
    <div v-if="item.couponListByProductVo" class="maizeng_name_box">
      <span class="bq_hong_man font10 font_weight500">
        {{ item.couponListByProductVo.couponTypeStr }}券
      </span>
      <span class="font12 font_weight400 colo087 coupon_msg">
        {{ item.couponListByProductVo.couponMessageStr }}
      </span>
    </div>

    <div class="con_pro">
      <div
        class="choose_img"
        @click="batchSingleSelect(item.id, item.isSelected)"
      >
        <!-- @/assets/login/unselect_icon@2x.png -->
        <img :src="item.isSelected ? selectImg : unSelectImg" alt="" />
      </div>
      <img
        :src="item.skuPic"
        alt=""
        class="product_img"
        @click="goProductDetail(item.spuId)"
      />
      <div class="name_con">
        <div
          class="name_title font12 font_weight400 colo087 font_line_2 text_left line_height_17"
        >
          {{ item.skuName }}
        </div>
        <!-- 规格 -->
        <div class="name_spec clearfix">
          <div
            class="left spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
            @click="chooseSpec(item.spuId, item.skuId)"
          >
            {{ item.skuSpec }}
            <span v-if="item.isExpiration == 1 && item.expiration"
              >；有效期至：{{ item.expiration }}</span
            >
            <img
              src="@/assets/common/icon_cell_more_24@2x.png"
              alt=""
              class="more_icon"
            />
          </div>
          <img
            src="@/assets/mine/icon_delete@2x.png"
            alt=""
            class="right delete_icon"
            @click="clickDelete"
          />
        </div>
        <!-- 标签 -->
        <!-- <div class="tags" v-if="item.activityType === 1">
          <div class="font10 font_weight500 colof00 line_height_14 tags_item">
            买赠
          </div>
        </div> -->
        <!-- 价格与步进器 -->
        <div class="name_price">
          <div class="main_price_box">
            <span class="font14 font_weight600 colo087 line_height_19">
              {{ (item.finalPrice || item.price) | currency(false) }}
            </span>
            <span
              v-if="item.singlePrice && item.uom"
              class="single_price font9 font_weight400"
            >
              {{ item.singlePrice | currency(false) }}/{{ item.uom }}
            </span>
          </div>
          <van-stepper
            v-model="item.amount"
            input-width="38px"
            button-size="15px"
            disable-input
            class="stepper_box"
            @change="changeNum"
          />
        </div>

        <!-- 优惠与税费 -->
        <div
          class="discount_tax_row"
          v-if="item.afterDiscountPrice || item.tax > 0"
        >
          <div
            v-if="item.afterDiscountPrice"
            class="beforeDiscount_price font10"
          >
            优惠价 {{ item.afterDiscountPrice | currency(false) }}
          </div>
          <div v-if="item.tax > 0" class="tax_price font10">
            含税 {{ item.tax | currency(false) }}
          </div>
        </div>

        <!-- 秒杀倒计时 -->
        <div v-if="item.seckillSkuAppVo" class="miaosha_tip_wrapper">
          <div class="miaosha_tip_box">
            <span class="ms_badge">秒杀</span>
            <span class="ms_line"></span>
            <span class="ms_subtext">距活动结束</span>
            <van-count-down
              :time="item.seckillSkuAppVo.remainingTime"
              format="HH:mm:ss"
              class="ms_countdown"
            />
          </div>
        </div>
      </div>
      <div
        v-if="deleteItem"
        class="delete_bg font12 font_weight400 colof"
        @click="deleteItem = false"
      >
        <!-- <div class="add_love" @click="addLove">加入收藏</div> -->
        <div class="delete_p" @click="deleteProduct(item.id)">删除</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  // <!-- @/assets/login/unselect_icon@2x.png -->
  //   <img src="@/assets/login/select@2x.png" alt="" />
  data() {
    return {
      value: "",
      deleteItem: false,
      selectImg: require("@/assets/login/select@2x.png"),
      unSelectImg: require("@/assets/login/unselect_icon@2x.png"),
      productSelect: false,
    };
  },
  mounted() {
    this.value = this.item.amount;
  },
  methods: {
    batchSingleSelect(id, isSelected) {
      this.$emit("batchSingleSelect", id, isSelected);
    },
    chooseSpec(spuId, skuId) {
      // console.log(1);
      this.$emit("chooseSpec", spuId, skuId, this.item.id);
    },
    clickDelete() {
      this.deleteItem = !this.deleteItem;
    },
    addLove() {
      this.$emit("addLove");
    },
    deleteProduct(id) {
      this.$emit("deleteProduct", id);
    },
    changeNum(value) {
      console.log(value, 222222);
      this.$emit("changeNum", value, this.item.id);
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    },
  },
};
</script>
<style lang="less" scoped>
.product_item_wrapper {
  background: #fff;
}
.mr_top {
  margin-top: 16px;
}
.maizeng_name_box {
  display: flex;
  align-items: center;
  padding: 0 12px 6px 42px;
  width: 100%;
  box-sizing: border-box;
  .bq_hong_man {
    color: #fff;
    background: linear-gradient(91deg, #ff5b83 17%, #fc2b5d 100%);
    border-radius: 2px;
    padding: 0 4px;
    height: 15px;
    line-height: 15px;
    font-size: 10px;
    font-weight: 500;
    flex-shrink: 0;
    margin-right: 4px;
  }
  .coupon_msg {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.con_pro {
  display: flex;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-right: 12px;
  position: relative;
  .choose_img {
    width: 42px;
    height: 96px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 18px;
    }
  }
  .product_img {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 4px;
    background-color: #f5f5f5;
  }
  .name_con {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    .name_title {
      width: 100%;
    }
    .name_spec {
      margin-top: 4px;
      .spec_det {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        max-width: 200px;
        overflow-y: hidden;
        display: flex;
        align-items: center;
      }
      .more_icon {
        width: 16px;
      }
      .delete_icon {
        width: 16px;
      }
    }
    .tags {
      margin-top: 4px;
      display: flex;
      height: 14px;
      .tags_item {
        padding: 0 4px;
        border: 1px solid #ff0000;
        margin-right: 4px;
      }
    }
    .name_price {
      margin-top: 4px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .main_price_box {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        // margin-right: 4px;
      }
      .single_price {
        color: rgba(0, 0, 0, 0.45);
        font-size: 10px;
        margin-left: 4px;
        line-height: 14px;
      }
      .stepper_box {
        flex-shrink: 0;
      }
      ::v-deep .van-stepper__minus {
        border-style: dashed;
        margin: 0 6px 0 0;
        background-color: #fff !important;
      }
      ::v-deep .van-stepper__plus {
        margin: 0 0 0 6px;
        background-color: #fff !important;
        color: #000;
        font-weight: bold !important;
      }
      ::v-deep .van-stepper__input {
        line-height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #000;
        height: 18px !important;
      }
    }
    .discount_tax_row {
      display: flex;
      flex-wrap: wrap;
      margin-top: 4px;
      .beforeDiscount_price {
        color: #fd2824;
        background-color: #fff5f4;
        padding: 1px 4px;
        border-radius: 2px;
        margin-right: 4px;
        font-size: 10px;
      }
      .tax_price {
        color: rgba(0, 0, 0, 0.45);
        background: #f6f7f8;
        padding: 1px 4px;
        border-radius: 2px;
        font-size: 10px;
      }
    }
    .miaosha_tip_wrapper {
      margin-top: 6px;
      display: flex;
    }
    .miaosha_tip_box {
      // display: inline-flex !important;
      // width: auto !important;
      // align-items: center;
      // background: linear-gradient(90deg, #fbf0f0 0%, #fff 100%);
      // border: 1px solid #fac2c6;
      // border-radius: 2px;
      // height: 18px;
      // box-sizing: border-box;
      // overflow: hidden;
      display: inline-flex;
      gap: 5px;
      background: linear-gradient(90deg, #fbf0f0, #ffffff 100%);
      border: 0.5px solid;
      border-image: linear-gradient(90deg, #f50e45, #ffffff 100%) 0.5 0.5;
      border-radius: 1px;
      align-items: center;
      height: 18px;
      padding: 2px 5px;
      box-sizing: border-box;
      .ms_badge {
        display: inline-flex;
        align-items: center;
        height: 100%;
        // padding: 0 4px;
        color: rgba(209, 6, 23, 1);
        font-size: 10px;
        font-weight: 500;
        white-space: nowrap;
      }
      .ms_line {
        width: 1px;
        height: 8px;
        background-color: #f2b9bd;
        flex-shrink: 0;
      }
      .ms_subtext {
        color: #d10617;
        font-size: 10px;
        // padding: 0 2px 0 4px;
        white-space: nowrap;
      }
      ::v-deep .van-count-down {
        color: #d10617;
        font-size: 10px;
        line-height: 1;
        padding-right: 4px;
      }
    }
  }
  .delete_bg {
    background: rgba(0, 0, 0, 0.65);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    vertical-align: middle;
    .add_love {
      width: 70px;
      height: 70px;
      line-height: 70px;
      border-radius: 50%;
      margin-right: 50px;
      background: #bf9264;
    }
    .delete_p {
      width: 70px;
      height: 70px;
      line-height: 70px;
      border-radius: 50%;
      background: #f00;
    }
  }
}
</style>
